export default __webpack_public_path__ + "static/media/dpdlocal-spinner.79f19320.gif";